import {RouterModule, Routes} from "@angular/router";
import {
  FP_ROUTES, FS_ROUTES, HAS_ROLE_EGALIM
} from "../core/constants";
import {Auth2Guard} from "../core/services/security/auth2.guard";
import {NgModule} from "@angular/core";
import {EgalimRootComponent} from "./egalim-root.component";
import {FamilleEgalimComponent} from "./famille-egalim/famille-egalim.component";
import {StatistiquesEgalimComponent} from "./statistiques-egalim/statistiques-egalim.component";
import {PointTeledeclarationEgalimComponent} from "./points-teledeclaration-egalim/point-teledeclaration-egalim.component";

const routes: Routes = [
  {
    path: FP_ROUTES.EGALIM,
    component: EgalimRootComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [Auth2Guard],
    canActivateChild: [Auth2Guard],
    data: HAS_ROLE_EGALIM,
    children: [
      {
        path: FS_ROUTES.FAMILLES_EGALIM,
        component: FamilleEgalimComponent,
        data: HAS_ROLE_EGALIM
      },      {
        path: FS_ROUTES.POINT_TELEDECLARATION_EGALIM,
        component: PointTeledeclarationEgalimComponent,
        data: HAS_ROLE_EGALIM
      },
      {
        path: FS_ROUTES.EGALIM_STATISTIQUES,
        component: StatistiquesEgalimComponent,
        data: HAS_ROLE_EGALIM
      }
    ]
  }
]
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EgalimRoutingModule {
}
